// Package Imports
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import detector from 'i18next-browser-languagedetector';

// eslint-disable-next-line @typescript-eslint/no-floating-promises, import/no-named-as-default-member
i18n
  .use(Backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'hi', 'ma', 'be', 'gu', 'ar', 'en-SG'],
    backend: {
      loadPath: '/locales/{{lng}}.json',
    },
    fallbackLng: ['en', 'hi', 'ma', 'be', 'gu', 'ar', 'en-SG'],
    // You might want to set a specific fallback for en-SG

    // Optional: Add language detection options
    detection: {
      order: ['localStorage', 'cookie', 'navigator'],
      caches: ['localStorage', 'cookie'],
    },
    // Optional: Handle non-exact matches
    nonExplicitSupportedLngs: true,
  });

export default i18n;
